import { toast } from 'react-toastify';

import { capitalizeFirstLetter } from '.';

type HandleWeb3ErrorParams = {
  err: any;
  source: string;
  data?: any;
  shouldLog?: boolean;
};

const REJECTED = [
  'cancelled',
  'rejected',
  'denied',
  'declined',
  // 'User denied message signature',
  // 'Confirmation declined by user',
];

const TIMED_OUT = ['The request timed out', 'Request expired'];

export const isRejectedTransaction = (err: any) => {
  const errMessage: string = typeof err === 'string' ? err : err.message || '';
  return REJECTED.some((text) => errMessage.toLowerCase().includes(text.toLowerCase()));
};

export const handleWeb3Error = (params: HandleWeb3ErrorParams) => {
  const { err, source } = params;
  const errMessage: string = typeof err === 'string' ? err : err.message || '';

  if (isRejectedTransaction(errMessage)) {
    toast.info(`${capitalizeFirstLetter(source)}: Request rejected.`);
    console.log('User rejected request');
    return;
  }

  const isTimedOut = TIMED_OUT.some((text) => errMessage.includes(text));
  if (isTimedOut) {
    toast.info(`${capitalizeFirstLetter(source)}: Request timed out.`);
    console.log('Request timed out.');
    return;
  }

  let message = err.shortMessage || errMessage || `An error has occurred. Request failed.`;

  if (typeof err === 'object' && 'details' in err) {
    try {
      message = JSON.parse(err.details).message;
      // eslint-disable-next-line no-empty
    } catch {}
  }

  toast.error(`${capitalizeFirstLetter(source)} error: ${message}`);
  console.log(source, err);
  console.log({ ...err });
};
